import { render, staticRenderFns } from "./MinhaCarteira.vue?vue&type=template&id=9b08faec&scoped=true&"
import script from "./MinhaCarteira.vue?vue&type=script&lang=js&"
export * from "./MinhaCarteira.vue?vue&type=script&lang=js&"
import style0 from "./MinhaCarteira.vue?vue&type=style&index=0&id=9b08faec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b08faec",
  null
  
)

export default component.exports